import { RouteObject } from 'react-router-dom';
import { adminRoutes } from './adminRoutes';
import { authRoutes } from './authRoutes';
import { checkoutRoutes } from './checkoutRoutes';
import { eventSpecificRoutes } from './eventSpecificRoutes';
import { eventsRoutes } from './eventsRoutes';
import { generalRoutes } from './generalRoutes';
import { ordersRoutes } from './ordersRoutes';

export const allRoutes: RouteObject[] = [
  ...generalRoutes,
  ...adminRoutes,
  ...authRoutes,
  ...checkoutRoutes,
  ...eventSpecificRoutes,
  ...eventsRoutes,
  ...ordersRoutes,
];
